// @flow
// TODO: should be exchanged to redux-actions library
import { createRequestActions } from 'helpers/redux/createRequestActions'
import * as types from './actionTypes'

export const holidaysList = {
  get: createRequestActions({
    request: types.HOLIDAYS_LIST.GET.REQUEST,
    success: types.HOLIDAYS_LIST.GET.SUCCESS,
    fail: types.HOLIDAYS_LIST.GET.FAIL,
  }),
  post: createRequestActions({
    request: types.HOLIDAYS_LIST.POST.REQUEST,
    success: types.HOLIDAYS_LIST.POST.SUCCESS,
    fail: types.HOLIDAYS_LIST.POST.FAIL,
  }),
}

export const setPending = (pending: boolean) => ({
  type: types.HOLIDAY_LIST_SET_PENDING,
  payload: {
    pending,
  },
})
